export default __webpack_public_path__ + "static/media/airspeed.38e906ef.png";